import { Dispatch, SetStateAction } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";

interface SubadminListTopbarProps {
    searchTerm: string;
    setSearchTerm: Dispatch<SetStateAction<string>>;
}

const SubadminListTopbar: React.FC<SubadminListTopbarProps> = ({ searchTerm, setSearchTerm }) => {
    const navigate = useNavigate();

    return (
        <>
            <div className="table_header">
                <div className="left_s">
                    <Box className="search_box">
                        <SearchBar
                            value={searchTerm}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
                            onCross={() => setSearchTerm("")}
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search sub-admins..."
                        />
                    </Box>
                </div>
                <div className="right_s">
                    <Button className="btn btn_primary" onClick={() => navigate("/manage-subadmin/roles")}>
                        Roles
                    </Button>
                    <Button className="btn btn_primary" onClick={() => navigate("/manage-subadmin/add")}>
                        <AddIcon /> Add Sub-Admin
                    </Button>
                </div>
            </div>
        </>
    );
};

export default SubadminListTopbar;
